export const IconTriangleRight = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
<path d="M8 8L0.5 0.205773L0.500001 15.7942L8 8Z" fill="var(--U-colors-Blue)"/>
</svg>`;
